import actions from '@/core/store/compras-legado/actions'

export default {
	actions,
}
